import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import SectionHeader from "../sectionHeader";
import SectionSubHeader from "../sectionSubHeader";

const ValuesCulture = () => {
  return (
    <div className="volto-section our-culture-section pb-80" id="volto-way">
      <Container>
        <Row className='tab-row'>
          <SectionHeader mainText1={"OUR VALUES "} mainText2={"& CULTURE"} />
          <Col lg={6}>
            <SectionSubHeader headerText={"Core Values"} />
          </Col>
          <Col lg={6}>
            <p className="about-volto-text mt-4 mt-lg-0">
              Innovation, Integrity, Collaboration, Customer Focus, and
              Excellence drive everything we do at Volto.
            </p>
          </Col>
        </Row>
        <div className="core-values-card-row">
          <div className="core-card">
            <span className="shape-clip"></span>
            <h3>Customer Centricity </h3>
            <p>Putting customers first with impactful solutions.</p>
          </div>
          <div className="core-card">
            {" "}
            <span className="shape-clip"></span>
            <h3>Continuous Growth </h3>
            <p>Evolving through learning and innovation.</p>
          </div>
          <div className="core-card">
            {" "}
            <span className="shape-clip"></span>
            <h3>Innovation Approach </h3>
            <p>Challenging limits to drive progress.</p>
          </div>
          <div className="core-card">
            {" "}
            <span className="shape-clip"></span>
            <h3>Agile Practices </h3>
            <p>Adapting quickly for efficiency and success.</p>
          </div>
          <div className="core-card">
            {" "}
            <span className="shape-clip"></span>
            <h3>Employee Focus </h3>
            <p>Empowering our people to thrive.</p>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default ValuesCulture;
